module.exports = __webpack_public_path__ + "img/section4Content4.05857419.png";